const breakPoint = 1105;

document.querySelectorAll("[data-toggler]").forEach((toggler) => {
	toggler.addEventListener("click", togglerToggle);
});

document.addEventListener("click", clearToggler);

function togglerToggle(e) {
	e.preventDefault();
	let togglerTarget = [this.dataset.toggler, new URL(this.href).hash].filter(selector => selector.length > 0).join(", ");
	document.querySelectorAll(togglerTarget).forEach((targetElement) => {
		targetElement.classList.toggle("toggler-active");

		if(innerWidth > breakPoint) {
			document.querySelectorAll(".toggler-active").forEach(otherToggler => {
				if(otherToggler === targetElement
				|| otherToggler.contains(targetElement)) {
					return;
				}

				otherToggler.classList.remove("toggler-active");
			});
		}
	});
	this.classList.toggle("toggler-self-active");
}

function clearToggler(e) {
	if(e.target.closest("global-header nav")) {
		return;
	}

	document.querySelectorAll(".toggler-active").forEach(activeToggler => {
		activeToggler.classList.remove("toggler-active");
	});
}
